<template>
  <span
    v-if="$slots.default && $slots.default[0]"
    :style="{
      fontSize: icon_font_size
    }"
    :class="$slots.default[0].text"
    class="sidearm-mm-icon"
    aria-hidden="true"
  ></span>
</template>

<script>
export default {
  props: {
    size: {
      type: [String, Number],
      required: false,
      default: "inherit"
    }
  },

  computed: {
    icon_font_size() {
      if (isNaN(this.size)) {
        return this.size;
      }

      return `${this.size}px`;
    }
  }
};
</script>

<style lang="scss">
@keyframes slidein {
  0% {
    transform: translateX(0);
  }
  10% {
    transform: translateX(25%);
  }
  20% {
    transform: translateX(0);
  }
  30% {
    transform: translateX(25%);
  }
  40% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(0);
  }
}
.--hint {
  animation: 2.5s linear 1s infinite slidein;
  display: inline-block;
}
</style>

<style lang="scss" scoped>
.sidearm-mm-icon {
  line-height: 1;
  vertical-align: middle;

  &::before {
    margin: 0;
  }
  &.color {
    &.--primary {
      color: $color-primary;
    }

    &.--success {
        color: $color-success;
    }
  }
  
}
</style>
